import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../lib/consent';

const SUFFIX = 'Kepp & Co.';
const SITE_URL = 'https://kepp-co.dk';
const DEFAULT_DESC =
  'Kepp & Co. er fagentreprenør i systemlofter, gipsvægge og akustikplader til hovedentreprenører og professionelle bygherrer på Sjælland.';

const pages = {
  '/': {
    title: 'Kepp & Co. | Systemlofter, gipsvægge og akustikplader',
    desc: DEFAULT_DESC,
  },
  '/om-kepp': {
    title: `Om os | ${SUFFIX}`,
    desc: 'Fagentreprenør med blik for helheden. Faglig stolthed, åbenhed, ansvar og leverancesikkerhed i professionelt byggeri.',
  },
  '/fagentreprise': {
    title: `Fagentreprise: systemlofter, gipsvægge og akustikplader | ${SUFFIX}`,
    desc: 'Systemlofter, gipsvægge og akustikplader udført efter projektets tegninger med præcis montage og tæt koordinering.',
  },
  '/asset-managers': {
    title: `Asset Managers & pensionskasser | ${SUFFIX}`,
    desc: 'Fagentrepriser med dokumenteret kvalitet, forudsigelighed og dokumentation til ESG og compliance for erhvervsejendomme på Sjælland.',
  },
  '/hovedentreprenorer': {
    title: `Hovedentreprenører | ${SUFFIX}`,
    desc: 'En fagentreprenør, der møder forberedt, holder tempoet og tager ansvar for tegninger, koordinering og fremdrift.',
  },
  '/dokumentation-kvalitet': {
    title: `Dokumentation & kvalitetssikring | ${SUFFIX}`,
    desc: 'Kvalitetssikring fra første registrering til endelig aflevering, med sporbar dokumentation gennem hele forløbet.',
  },
  '/kontakt': {
    title: `Kontakt | ${SUFFIX}`,
    desc: 'Kontakt Kepp & Co., Meterbuen 6, Bygning 9, 2740 Skovlunde. Tlf. 60 10 10 25 · mail@kepp-co.dk.',
  },
  '/privatlivspolitik': {
    title: `Privatlivspolitik | ${SUFFIX}`,
    desc: 'Sådan behandler Kepp & Co. personoplysninger fra kontaktformular, e-mail og hjemmesidestatistik.',
  },
  '/cookiepolitik': {
    title: `Cookiepolitik | ${SUFFIX}`,
    desc: 'Oversigt over cookies på Kepp & Co.s hjemmeside og hvordan du ændrer dit samtykke.',
  },
};

let lastTracked = null;

const Seo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = pages[pathname] || pages['/'];
    const url = `${SITE_URL}${pages[pathname] ? pathname : '/'}`;
    document.title = meta.title;
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', url);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', url);
    document.querySelector('meta[name="description"]')?.setAttribute('content', meta.desc);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', meta.title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', meta.desc);
    if (lastTracked !== pathname) {
      lastTracked = pathname;
      trackEvent('kepp_page_view', { page_path: pathname, page_title: meta.title });
    }
  }, [pathname]);
  return null;
};

export default Seo;
